import React, { ReactElement } from "react"
import { Helmet } from "react-helmet"
import Header from "../components/header"
import SideNav from "../components/sideNav"
import useSiteMetadata from "../hooks/siteMetadata"

function Layout({
  children,
  title: pageTitle,
  description: pageDescription,
}: any): ReactElement {
  let { title, description } = useSiteMetadata()
  title = pageTitle ? `${pageTitle} - ${title}` : title

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={pageDescription || description} />
        <meta name="keywords" content="validation dotnet csharp c# builder" />
      </Helmet>
      <div className="container mx-auto max-w-screen-lg lg:px-4">
        <Header />
        <div className="flex">
          <div className="p-4 hidden md:flex md:w-1/2 lg:w-1/3 mt-2">
            <SideNav />
          </div>
          <div className="p-4 w-screen md:3/5 lg:w-2/3">{children}</div>
        </div>
      </div>
    </>
  )
}

export default Layout
